import { StrictMode } from 'react';
import { ThemeProvider, useMediaQuery } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import ReactDOM from 'react-dom/client';
import theme from './muiTheme';
import { domainCountryMap } from '@/config/domainMap';
import FontStyles from './styles/FontStyles.jsx';
import IncompatibleScreen from '@/common/IncompatibleScreen';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CountryNotFound from '@/common/CountryNotFound';
import useStore, { selectSetFavoriteCountryId, selectCountryTheme } from '@/hooks/client/useStore';
import { router } from './router.js';

const queryClient = new QueryClient();
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
const hostname = window.location.hostname;
const countryCode = domainCountryMap[hostname] || null;

const App = () => {
  const setCountryId = useStore(selectSetFavoriteCountryId);
  const isLargeScreen = useMediaQuery('(min-width:1200px)');
  const countryTheme = useStore(selectCountryTheme);

  if (countryCode) {
    setCountryId(countryCode);
    window.localStorage.setItem('selectedCountryId', countryCode);
  } else {
    return (
      <ThemeProvider theme={theme}>
        <CountryNotFound />
      </ThemeProvider>
    );
  }

  if (isLargeScreen) {
    return <IncompatibleScreen />;
  }

  if (countryTheme) {
    document.querySelector('footer').style.backgroundColor = countryTheme.navColor;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FontStyles />
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryClientProvider>
  );
};

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
